import { render } from "./BaseInput.vue?vue&type=template&id=0c820e88&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=0c820e88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c820e88"

export default script